// src/components/product-headline/product-headline.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    spotLight\n    title\n    theme\n    token\n    withBackground\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    graphic {\n      ...EGDSIconFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment ProductSupportingMessageFragment on ProductSupportingMessage {\n    ... on EGDSPlainText {\n      text\n    }\n    ... on EGDSStandardBadge {\n      badgeText: text\n      theme\n    }\n    ... on EGDSInlineLink {\n      text\n      action {\n        analytics {\n          linkName\n          referrerId\n        }\n        resource {\n          value\n          ... on HttpURI {\n            relativePath\n          }\n        }\n        target\n        useRelativePath\n      }\n    }\n    ...EGDSGraphicTextFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  query ProductHeadlineQuery($productIdentifier: ProductIdentifierInput!, $context: ContextInput!) {\n    productHeadline(productIdentifier: $productIdentifier, context: $context) {\n      primary\n      secondary\n      rating {\n        rating\n        icon {\n          id\n          description\n          theme\n        }\n        accessibility\n      }\n      featuredMessages {\n        ...ProductSupportingMessageFragment\n      }\n      supportingMessages {\n        ...ProductSupportingMessageFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import React14 from "react";
import { gql as gql4, useQuery } from "@apollo/client";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSRating } from "@egds/react-core/rating";
import { EGDSLineSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSSubheading, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useMockData } from "@shared-ui/retail-product-type-providers";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
// src/components/product-headline/__private/__fragments/messages.tsx
import React13 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSBadgeStandard } from "@egds/react-core/badge";
import { EGDSIcon as EGDSIcon2, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { EGDSText } from "@egds/react-core/text";
// ../internal/src/components/egds-graphic-text/egds-graphic-text.tsx
import React11 from "react";
import { gql as gql2 } from "@apollo/client";
// ../../../../node_modules/.pnpm/tslib@2.3.1/node_modules/tslib/tslib.es6.js
var __assign = function __assign1() {
    __assign = Object.assign || function __assign2(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for(var i = 0, l = from.length, ar; i < l; i++){
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
// ../../../../node_modules/.pnpm/uitk-react-text@4.12.3_@egds+tokens-web@5.4.26_react@17.0.2_tslib@2.3.1_uitk-react-utils@3.2.2_react@17.0.2_tslib@2.3.1_/node_modules/uitk-react-text/dist/types.esm.js
var UitkTypeSizeMap = [
    [
        100,
        "uitk-type-100"
    ],
    [
        200,
        "uitk-type-200"
    ],
    [
        300,
        "uitk-type-300"
    ],
    [
        400,
        "uitk-type-400"
    ],
    [
        500,
        "uitk-type-500"
    ],
    [
        600,
        "uitk-type-600"
    ],
    [
        700,
        "uitk-type-700"
    ],
    [
        800,
        "uitk-type-800"
    ],
    [
        900,
        "uitk-type-900"
    ]
];
var UitkTypeSizes = new Map(UitkTypeSizeMap);
var UitkTypeWeightMap = [
    [
        "regular",
        "uitk-type-regular"
    ],
    [
        "medium",
        "uitk-type-medium"
    ],
    [
        "bold",
        "uitk-type-bold"
    ]
];
var UitkTypeWeights = new Map(UitkTypeWeightMap);
var UitkTypeAlignmentMap = [
    [
        "left",
        "uitk-type-start"
    ],
    [
        "right",
        "uitk-type-end"
    ],
    [
        "center",
        "uitk-type-center"
    ]
];
var UitkTypeAlignments = new Map(UitkTypeAlignmentMap);
var UitkTypeOverflowMap = [
    [
        "wrap",
        "overflow-wrap"
    ],
    [
        "truncate",
        "truncate"
    ],
    [
        "truncate-2-lines",
        "truncate-lines-2"
    ],
    [
        "truncate-3-lines",
        "truncate-lines-3"
    ],
    [
        "truncate-4-lines",
        "truncate-lines-4"
    ]
];
var UitkTypeOverflows = new Map(UitkTypeOverflowMap);
var UitkTypeHyphensMap = [
    [
        "none",
        "hyphens-none"
    ],
    [
        "manual",
        "hyphens-manual"
    ],
    [
        "auto",
        "hyphens-auto"
    ]
];
var UitkTypeHyphens = new Map(UitkTypeHyphensMap);
var UitkHeadingSizeMap = [
    [
        1,
        "uitk-heading-1"
    ],
    [
        2,
        "uitk-heading-2"
    ],
    [
        3,
        "uitk-heading-3"
    ],
    [
        4,
        "uitk-heading-4"
    ],
    [
        5,
        "uitk-heading-5"
    ],
    [
        6,
        "uitk-heading-6"
    ],
    [
        7,
        "uitk-heading-7"
    ],
    [
        8,
        "uitk-heading-8"
    ]
];
var UitkHeadingSizes = new Map(UitkHeadingSizeMap);
var UitkParagraphSizeMap = [
    [
        1,
        "uitk-paragraph-1"
    ],
    [
        2,
        "uitk-paragraph-2"
    ],
    [
        3,
        "uitk-paragraph-3"
    ]
];
var UitkParagraphSizes = new Map(UitkParagraphSizeMap);
var UitkTypeMarginMap = [
    [
        "half",
        "uitk-text-spacing-half"
    ],
    [
        "one",
        "uitk-text-spacing-one"
    ],
    [
        "two",
        "uitk-text-spacing-two"
    ],
    [
        "three",
        "uitk-text-spacing-three"
    ],
    [
        "four",
        "uitk-text-spacing-four"
    ],
    [
        "six",
        "uitk-text-spacing-six"
    ]
];
var UitkTypeMargins = new Map(UitkTypeMarginMap);
var UitkHeadingTagMap = [
    [
        "h1",
        "h1"
    ],
    [
        "h2",
        "h2"
    ],
    [
        "h3",
        "h3"
    ],
    [
        "h4",
        "h4"
    ],
    [
        "h5",
        "h5"
    ],
    [
        "h6",
        "h6"
    ]
];
var UitkHeadingTags = new Map(UitkHeadingTagMap);
var UitkSubHeadingTagMap = __spreadArray(__spreadArray([], UitkHeadingTagMap, true), [
    [
        "p",
        "p"
    ]
], false);
var UitkSubHeadingTags = new Map(UitkSubHeadingTagMap);
var UitkTextThemeMap = [
    [
        "positive",
        "uitk-text-positive-theme"
    ],
    [
        "negative",
        "uitk-text-negative-theme"
    ],
    [
        "emphasis",
        "uitk-text-emphasis-theme"
    ],
    [
        "default",
        "uitk-text-default-theme"
    ],
    [
        "loyalty",
        "uitk-text-loyalty-theme"
    ],
    [
        "global-loyalty",
        "uitk-text-global-loyalty-theme"
    ],
    [
        "inverse",
        "uitk-text-inverse-theme"
    ],
    [
        "light",
        "uitk-text-light-theme"
    ],
    [
        "standard",
        "uitk-text-standard-theme"
    ],
    [
        "secondary",
        "uitk-text-secondary-theme"
    ]
];
var UitkTextThemes = new Map(UitkTextThemeMap);
var UitkTypeWhiteSpaceMap = [
    [
        "normal",
        "uitk-text-white-space-normal"
    ],
    [
        "nowrap",
        "uitk-text-white-space-nowrap"
    ],
    [
        "pre",
        "uitk-text-white-space-pre"
    ],
    [
        "pre-wrap",
        "uitk-text-white-space-pre-wrap"
    ],
    [
        "pre-line",
        "uitk-text-white-space-pre-line"
    ],
    [
        "break-spaces",
        "uitk-text-white-space-break-spaces"
    ]
];
var UitkTypeWhiteSpaces = new Map(UitkTypeWhiteSpaceMap);
var UitkTextInlineTagsMap = [
    [
        "b",
        "b"
    ],
    [
        "em",
        "em"
    ],
    [
        "s",
        "s"
    ],
    [
        "small",
        "small"
    ],
    [
        "i",
        "i"
    ],
    [
        "mark",
        "mark"
    ],
    [
        "strong",
        "strong"
    ],
    [
        "q",
        "q"
    ],
    [
        "sub",
        "sub"
    ],
    [
        "sup",
        "sup"
    ]
];
var UitkTextInlineTags = new Map(UitkTextInlineTagsMap);
// ../../../../node_modules/.pnpm/uitk-react-utils@3.2.2_react@17.0.2_tslib@2.3.1/node_modules/uitk-react-utils/dist/classnames.esm.js
function classNames() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++){
        args[_i] = arguments[_i];
    }
    var classes = [];
    var _this = typeof window !== "undefined" && this === window ? void 0 : this;
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var arg = args_1[_a];
        if (!arg) {
            continue;
        }
        var argType = typeof arg === "undefined" ? "undefined" : _type_of(arg);
        if (argType === "string") {
            var argStrToArray = arg.split(" ");
            if (_this && argStrToArray.length > 1) {
                classes.push(classNames.apply(_this, argStrToArray));
            } else {
                classes.push((_this === null || _this === void 0 ? void 0 : _this[arg]) || arg);
            }
        } else if (Array.isArray(arg)) {
            [].concat.apply([], arg).filter(Boolean).length && classes.push(classNames.apply(_this !== null && _this !== void 0 ? _this : null, arg));
        } else if (argType === "object") {
            if (arg.toString === Object.prototype.toString) {
                for(var key in arg){
                    if (({}).hasOwnProperty.call(arg, key) && arg[key]) {
                        classes.push((_this === null || _this === void 0 ? void 0 : _this[key]) || key);
                    }
                }
            } else {
                classes.push(arg.toString());
            }
        }
    }
    return classes.join(" ");
}
// ../../../../node_modules/.pnpm/uitk-react-utils@3.2.2_react@17.0.2_tslib@2.3.1/node_modules/uitk-react-utils/dist/uitk-context-provider.esm.js
import * as React from "react";
var Context = React.createContext({
    context: null
});
var useUitkContext = function useUitkContext() {
    return React.useContext(Context);
};
var UitkContextProvider = function UitkContextProvider(_a) {
    var children = _a.children, config = _a.config;
    return React.createElement(Context.Provider, {
        value: config
    }, children);
};
UitkContextProvider.displayName = "UitkContextProvider";
// ../../../../node_modules/.pnpm/uitk-react-utils@3.2.2_react@17.0.2_tslib@2.3.1/node_modules/uitk-react-utils/dist/validate-prop-types.esm.js
var validatePropType = function validatePropType(prop, type) {
    if (prop && type) {
        var PropAvailability = Object.keys(type).map(function(key) {
            return type[key];
        }).indexOf(prop) > -1;
        if (!PropAvailability) {
            console.error(PropAvailability, "Expected values: ".concat(Object.keys(type).join(", ")));
        }
        return PropAvailability;
    }
};
// ../../../../node_modules/.pnpm/uitk-react-utils@3.2.2_react@17.0.2_tslib@2.3.1/node_modules/uitk-react-utils/dist/index.esm.js
if (typeof document !== "undefined") {
    addBodyClass_1 = function() {
        if (!document.body.classList.contains("uitk-no-outline")) {
            document.body.classList.add("uitk-no-outline");
            document.body.removeEventListener("mousedown", addBodyClass_1);
            document.body.addEventListener("keydown", removeBodyClass_1);
        }
    };
    removeBodyClass_1 = function() {
        if (document.body.classList.contains("uitk-no-outline")) {
            document.body.classList.remove("uitk-no-outline");
            document.body.removeEventListener("keydown", removeBodyClass_1);
            document.body.addEventListener("mousedown", addBodyClass_1);
        }
    };
    addBodyClass_1();
}
var addBodyClass_1;
var removeBodyClass_1;
// ../../../../node_modules/.pnpm/uitk-react-text@4.12.3_@egds+tokens-web@5.4.26_react@17.0.2_tslib@2.3.1_uitk-react-utils@3.2.2_react@17.0.2_tslib@2.3.1_/node_modules/uitk-react-text/dist/uitk-text.css
var uitk_text_default = {};
// ../../../../node_modules/.pnpm/uitk-react-text@4.12.3_@egds+tokens-web@5.4.26_react@17.0.2_tslib@2.3.1_uitk-react-utils@3.2.2_react@17.0.2_tslib@2.3.1_/node_modules/uitk-react-text/dist/uitk-text.esm.js
import * as React2 from "react";
var getClassNameList = classNames.bind(uitk_text_default);
var UitkText = function UitkText(props) {
    var align = props.align, children = props.children, inline = props.inline, passedInSize = props.size, spacing = props.spacing, overflow = props.overflow, weight = props.weight, whiteSpace = props.whiteSpace, className = props.className, _a = props.theme, theme = _a === void 0 ? "default" : _a, _b = props.wordBreak, wordBreak = _b === void 0 ? false : _b, dataTestId = props.dataTestId, hyphens = props.hyphens, attributes = __rest(props, [
        "align",
        "children",
        "inline",
        "size",
        "spacing",
        "overflow",
        "weight",
        "whiteSpace",
        "className",
        "theme",
        "wordBreak",
        "dataTestId",
        "hyphens"
    ]);
    var isPhraseTag = inline && typeof inline === "string";
    var size = !isPhraseTag && !passedInSize ? 300 : passedInSize;
    var Tag;
    if (inline && typeof inline === "boolean") {
        Tag = "span";
    } else if (isPhraseTag) {
        Tag = inline;
    } else {
        Tag = "div";
    }
    var contextData = useUitkContext().data;
    var _c = contextData !== null && contextData !== void 0 ? contextData : {}, bottomScrimContext = _c.bottomScrimContext, overlayScrimContext = _c.overlayScrimContext, contextClassNames = _c.contextClassNames;
    var wrapperClassNames = getClassNameList("uitk-text", align && UitkTypeAlignments.get(align), spacing && UitkTypeMargins.get(spacing), overflow && !inline && UitkTypeOverflows.get(overflow), wordBreak && !inline && UitkTypeOverflows.get("wrap"), hyphens && UitkTypeHyphens.get(hyphens), !bottomScrimContext && size && UitkTypeSizes.get(size), !bottomScrimContext && weight && UitkTypeWeights.get(weight), whiteSpace && UitkTypeWhiteSpaces.get(whiteSpace), bottomScrimContext && "in-bottom-scrim", overlayScrimContext && "in-overlay-scrim", !(bottomScrimContext || overlayScrimContext) && theme && UitkTextThemes.get(theme), contextClassNames === null || contextClassNames === void 0 ? void 0 : contextClassNames.UitkText, className);
    return children ? React2.createElement(Tag, __assign({
        className: wrapperClassNames
    }, dataTestId ? {
        "data-test-id": dataTestId
    } : {}, attributes), children) : null;
};
UitkText.displayName = "UitkText";
// ../internal/src/components/egds-icon/egds-icon.tsx
import React10 from "react";
import { gql } from "@apollo/client";
// ../../../../node_modules/.pnpm/@shared-ui+brand-context@0.0.8_react@17.0.2/node_modules/@shared-ui/brand-context/dist/esmodule/brand-context.js
import * as React3 from "react";
var DEFAULTS = {
    getIcon: function getIcon(name) {
        return null;
    },
    getIconPath: function getIconPath(name) {
        return null;
    },
    getIconsHref: function getIconsHref(name) {
        return null;
    }
};
var Context2 = React3.createContext(DEFAULTS);
var BrandProvider = function BrandProvider(props) {
    return React3.createElement(Context2.Provider, {
        value: props.config || DEFAULTS
    }, props.children);
};
BrandProvider.displayName = "BrandProvider";
var useBrand = function useBrand() {
    return React3.useContext(Context2);
};
// ../../../../node_modules/.pnpm/@shared-ui+experiment-context@2.0.2_react@17.0.2/node_modules/@shared-ui/experiment-context/dist/esmodule/experiment-context.js
import * as React4 from "react";
var defaults = {
    getExposure: function getExposure(name) {
        return null;
    },
    logExperiment: function logExperiment(exposure) {
        return void 0;
    }
};
var ExperimentContext = React4.createContext(defaults);
// ../../../../node_modules/.pnpm/@shared-ui+experiment-context@2.0.2_react@17.0.2/node_modules/@shared-ui/experiment-context/dist/esmodule/components/experiment-control.js
import * as React5 from "react";
// ../../../../node_modules/.pnpm/@shared-ui+experiment-context@2.0.2_react@17.0.2/node_modules/@shared-ui/experiment-context/dist/esmodule/components/experiment-variant.js
import * as React6 from "react";
// ../../../../node_modules/.pnpm/@shared-ui+experiment-context@2.0.2_react@17.0.2/node_modules/@shared-ui/experiment-context/dist/esmodule/components/experiment.js
import * as React7 from "react";
import { useContext as useContext3, useEffect } from "react";
var useExperiment = function useExperiment(name, shouldLogExperiment) {
    var _a;
    var _b = useContext3(ExperimentContext), getExposure = _b.getExposure, logExperiment = _b.logExperiment;
    var exposure = (_a = getExposure(name)) !== null && _a !== void 0 ? _a : {
        name: name,
        bucket: 0
    };
    useEffect(function() {
        if (exposure && shouldLogExperiment) {
            try {
                logExperiment(exposure);
            } catch (e) {}
        }
    }, [
        logExperiment
    ]);
    return {
        exposure: exposure,
        logExperiment: logExperiment
    };
};
// ../../../../node_modules/.pnpm/@shared-ui+experiment-context@2.0.2_react@17.0.2/node_modules/@shared-ui/experiment-context/dist/esmodule/components/mock-experiment-provider.js
import * as React8 from "react";
// ../../../../node_modules/.pnpm/uitk-react-icons@10.10.4_@egds+tokens-web@5.4.26_@shared-ui+brand-context@0.0.8_react@17.0.2__6gtxuldvo6difm37rofsu4cnha/node_modules/uitk-react-icons/dist/uitk-icon.esm.js
import * as React9 from "react";
// ../../../../node_modules/.pnpm/uitk-react-icons@10.10.4_@egds+tokens-web@5.4.26_@shared-ui+brand-context@0.0.8_react@17.0.2__6gtxuldvo6difm37rofsu4cnha/node_modules/uitk-react-icons/dist/types.esm.js
var UitkIconThemeMap = [
    [
        "positive",
        "uitk-icon-positive-theme"
    ],
    [
        "negative",
        "uitk-icon-negative-theme"
    ],
    [
        "primary",
        "uitk-icon-primary-theme"
    ],
    [
        "secondary",
        "uitk-icon-secondary-theme"
    ],
    [
        "inverse",
        "uitk-icon-inverse-theme"
    ],
    [
        "emphasis",
        "uitk-icon-emphasis-theme"
    ],
    [
        "default",
        "uitk-icon-default-theme"
    ]
];
var UitkIconThemes = new Map(UitkIconThemeMap);
// ../../../../node_modules/.pnpm/uitk-react-icons@10.10.4_@egds+tokens-web@5.4.26_@shared-ui+brand-context@0.0.8_react@17.0.2__6gtxuldvo6difm37rofsu4cnha/node_modules/uitk-react-icons/dist/uitk-icons.css
var uitk_icons_default = {};
// ../../../../node_modules/.pnpm/uitk-react-icons@10.10.4_@egds+tokens-web@5.4.26_@shared-ui+brand-context@0.0.8_react@17.0.2__6gtxuldvo6difm37rofsu4cnha/node_modules/uitk-react-icons/dist/uitk-icon.esm.js
var getClassNameList2 = classNames.bind(uitk_icons_default);
var UitkIconSize;
(function(UitkIconSize2) {
    UitkIconSize2["EXTRA_SMALL"] = "xsmall";
    UitkIconSize2["SMALL"] = "small";
    UitkIconSize2["MEDIUM"] = "medium";
    UitkIconSize2["LARGE"] = "large";
    UitkIconSize2["XLARGE"] = "xlarge";
})(UitkIconSize || (UitkIconSize = {}));
var UitkIcon = function UitkIcon(props) {
    var _a;
    var baseCssClass = "uitk-icon";
    var throwNameError = function throwNameError(nameError) {
        typeof window !== "undefined" && console.error("Invalid icon name prop: ".concat(nameError));
    };
    var className = props.className, description = props.description, id = props.id, name = props.name, size = props.size, theme = props.theme, title = props.title, shadow = props.shadow, spotlight = props.spotlight;
    var contextData = useUitkContext().data;
    var contextClassNames = (contextData !== null && contextData !== void 0 ? contextData : {}).contextClassNames;
    if (!name) {
        throwNameError(name);
    }
    if ((title || description) && !id && typeof window !== "undefined") {
        console.error("Icon ".concat(name, " requires 'id' if 'title' or 'description' are provided"));
    }
    var dropShadowValues = {
        dx: 0,
        dy: 0,
        stdDeviation: 1
    };
    var uid = Math.random().toString(36).substring(7);
    var filterId = "shadow-filter".concat(id ? "-".concat(id) : "-".concat(uid));
    var domRef = function domRef(b) {};
    var isDirectional = name && /_(?:back|forward|left|right|before|next|half)$/.test(name);
    var spotLightIsObject = typeof spotlight === "object";
    var newSpotlight = false;
    if (spotLightIsObject) {
        newSpotlight = spotlight;
    } else if (spotlight) {
        newSpotlight = {
            theme: spotlight,
            background: true
        };
    }
    var wrapperClassNames = getClassNameList2(baseCssClass, className, contextClassNames === null || contextClassNames === void 0 ? void 0 : contextClassNames.UitkIcon, (_a = {}, _a["".concat(baseCssClass, "-directional")] = isDirectional, _a["".concat(baseCssClass, "-").concat(size)] = validatePropType(size, UitkIconSize) && !spotlight && size !== UitkIconSize.MEDIUM, _a["".concat(baseCssClass, "-spotlight-icon")] = newSpotlight, _a), theme && !spotlight && UitkIconThemes.get(theme));
    var spotlightIconContainerClassNames = getClassNameList2(newSpotlight && [
        "".concat(baseCssClass, "-spotlight"),
        "".concat(baseCssClass, "-spotlight-").concat(newSpotlight.theme),
        newSpotlight.background && "".concat(baseCssClass, "-spotlight-has-background")
    ]);
    var isSVGFEDropShadowElement = typeof SVGFEDropShadowElement === "function";
    var style = shadow && isSVGFEDropShadowElement ? {
        filter: "url(#".concat(filterId, ")")
    } : void 0;
    var getIconPath = useBrand().getIconPath;
    var pathToRender = function pathToRender(svgName) {
        var iconToRender = (svgName === null || svgName === void 0 ? void 0 : svgName.indexOf("icon__")) === 0 ? svgName.replace("icon__", "") : svgName;
        var iconPathString = getIconPath === null || getIconPath === void 0 ? void 0 : getIconPath(iconToRender);
        iconPathString || throwNameError(svgName);
        return iconPathString || "";
    };
    var svgNodes = [
        title && '<title id="'.concat(id, '-title">').concat(title, "</title>"),
        description && '<desc id="'.concat(id, '-description">').concat(description, "</desc>"),
        shadow && '<defs>\n      <filter id="'.concat(filterId, '">\n        <feDropShadow dx="').concat(dropShadowValues.dx, '" dy="').concat(dropShadowValues.dy, '" stdDeviation="').concat(dropShadowValues.stdDeviation, '"/>\n      </filter>\n    </defs>')
    ].filter(Boolean).join("");
    var a11yProps = {
        "aria-describedby": description ? "".concat(id, "-description") : void 0,
        "aria-hidden": title || description ? void 0 : true,
        "aria-label": title || void 0,
        role: title || description ? "img" : void 0
    };
    var iconProps = {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    };
    var svgProps = __assign(__assign({
        ref: domRef,
        className: wrapperClassNames,
        style: style
    }, a11yProps), iconProps);
    var innerNodes = function innerNodes(html) {
        if (html.length > 0) {
            return {
                dangerouslySetInnerHTML: {
                    __html: html
                }
            };
        }
        return {};
    };
    var exposure = useExperiment("Bernie_SVG_delivery", true).exposure;
    var innerNodesMarkup = (exposure === null || exposure === void 0 ? void 0 : exposure.bucket) === 1 || (exposure === null || exposure === void 0 ? void 0 : exposure.bucket) === 2 ? "".concat(svgNodes, '<use href="#').concat(name, '" />') : "".concat(svgNodes).concat(pathToRender(name));
    var iconMarkup = React9.createElement("svg", __assign({}, svgProps, innerNodes(innerNodesMarkup)));
    return spotlight ? React9.createElement("div", {
        className: spotlightIconContainerClassNames
    }, iconMarkup) : iconMarkup;
};
UitkIcon.defaultProps = {
    size: UitkIconSize.MEDIUM
};
UitkIcon.displayName = "UitkIcon";
var _obj;
// ../internal/src/components/egds-icon/__private/spotlight-mapper.ts
var spotlightMapper = (_obj = {}, _define_property(_obj, "INFO" /* INFO */ , "info"), _define_property(_obj, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj, "WARNING" /* WARNING */ , "warning"), _define_property(_obj, "STANDARD" /* STANDARD */ , "standard"), _obj);
// ../internal/src/components/egds-icon/egds-icon.tsx
var fragment = gql(_templateObject());
var EGDSIcon = function(param) {
    var className = param.className, defaultIconSize = param.defaultIconSize, data = param.data, spotlight = param.spotlight;
    var id = data.id, token = data.token;
    if (!id || !token) {
        return null;
    }
    var description = data.description, withBackground = data.withBackground, size = data.size, spotLightData = data.spotLight, title = data.title, theme = data.theme;
    return /* @__PURE__ */ React10.createElement(UitkIcon, {
        className: className,
        description: description,
        id: id,
        name: token,
        shadow: withBackground !== null && withBackground !== void 0 ? withBackground : void 0,
        size: size ? UitkIconSize[size] : defaultIconSize,
        spotlight: spotLightData ? spotlightMapper[spotLightData] : spotlight,
        title: title !== null && title !== void 0 ? title : void 0,
        theme: theme !== null && theme !== void 0 ? theme : void 0
    });
};
EGDSIcon.fragment = fragment;
EGDSIcon.displayName = "UitkIcon";
// ../internal/src/components/egds-graphic-text/egds-graphic-text.tsx
var fragment2 = gql2(_templateObject1(), EGDSIcon.fragment);
var EGDSGraphicText = function(param) {
    var data = param.data, textProps = param.textProps, _param_size = param.size, size = _param_size === void 0 ? 200 : _param_size;
    if (!(data === null || data === void 0 ? void 0 : data.text)) {
        return null;
    }
    var text = data.text, graphic = data.graphic;
    var graphicElement2 = function() {
        if (graphic.__typename === "Icon") {
            return /* @__PURE__ */ React11.createElement(EGDSIcon, {
                data: graphic
            });
        }
    };
    return /* @__PURE__ */ React11.createElement(UitkText, _object_spread({
        size: size
    }, textProps), graphicElement2(), text);
};
EGDSGraphicText.fragment = fragment2;
EGDSGraphicText.displayName = "EGDSGraphicText";
// src/components/product-headline/__private/__fragments/dialog-trigger-link.tsx
import React12 from "react";
import { EGDSLink } from "@egds/react-core/link";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { useRefContext } from "@shared-ui/ref-context";
var DialogTriggerLink = function(param) {
    var data = param.data, dialogId = param.dialogId, refName = param.refName;
    var clickTracker = useClickTracker();
    var _useDialog = _sliced_to_array(useDialog(dialogId), 2), dialogActions = _useDialog[1];
    var registerTarget = useRefContext().registerTarget;
    var ref = registerTarget(refName);
    return /* @__PURE__ */ React12.createElement(EGDSLink, null, /* @__PURE__ */ React12.createElement("button", {
        type: "button",
        "data-stid": refName,
        id: refName,
        ref: ref,
        onClick: function() {
            var _data_action;
            if ((_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.analytics) {
                clickTracker(data.action.analytics.referrerId, data.action.analytics.linkName);
            }
            dialogActions.openDialog();
        }
    }, data.text));
};
// src/components/product-headline/__private/__fragments/messages.tsx
var __ProductSupportingMessageFragment = gql3(_templateObject2(), EGDSGraphicText.fragment);
var graphicElement = function(graphic) {
    if (graphic.__typename === "Icon") {
        return /* @__PURE__ */ React13.createElement(EGDSIcon2, {
            id: graphic.id,
            name: graphic.id,
            size: EGDSIconSize.SMALL,
            "aria-hidden": "true"
        });
    }
};
var getDialogTriggerProps = function(id) {
    switch(id){
        case "#property-summary-map":
            return {
                dialogId: "property-address-map",
                refName: "propertyAddressMapLink"
            };
        default:
            return {
                dialogId: "product-supporting-message-dialog",
                refName: "productSupportingMessageLink"
            };
    }
};
var ProductSupportingMessage = function(param) {
    var inline = param.inline, data = param.data;
    var _data_action_resource, _data_action;
    var isAddressMapLink = Boolean(data.__typename === "EGDSInlineLink" && ((_data_action = data.action) === null || _data_action === void 0 ? void 0 : (_data_action_resource = _data_action.resource) === null || _data_action_resource === void 0 ? void 0 : _data_action_resource.value) === "#property-summary-map");
    switch(data.__typename){
        case "EGDSGraphicText":
            return /* @__PURE__ */ React13.createElement(EGDSText, {
                inline: inline
            }, graphicElement(data.graphic), data.text);
        case "EGDSStandardBadge":
            if (!data.badgeText) {
                return null;
            }
            return /* @__PURE__ */ React13.createElement(EGDSBadgeStandard, {
                text: data.badgeText,
                theme: data.theme
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React13.createElement(EGDSText, {
                inline: inline
            }, data === null || data === void 0 ? void 0 : data.text);
        case "EGDSInlineLink":
            {
                var _data_action_resource1, _data_action1, _data_action_resource2, _data_action2;
                return /* @__PURE__ */ React13.createElement(React13.Fragment, null, isAddressMapLink ? /* @__PURE__ */ React13.createElement(DialogTriggerLink, _object_spread_props(_object_spread({}, getDialogTriggerProps((_data_action1 = data.action) === null || _data_action1 === void 0 ? void 0 : (_data_action_resource1 = _data_action1.resource) === null || _data_action_resource1 === void 0 ? void 0 : _data_action_resource1.value)), {
                    data: data
                })) : /* @__PURE__ */ React13.createElement(EGDSLink2, null, /* @__PURE__ */ React13.createElement("a", {
                    href: (_data_action2 = data.action) === null || _data_action2 === void 0 ? void 0 : (_data_action_resource2 = _data_action2.resource) === null || _data_action_resource2 === void 0 ? void 0 : _data_action_resource2.value
                }, data.text)));
            }
        default:
            return null;
    }
};
ProductSupportingMessage.displayName = "ProductSupportingMessage";
ProductSupportingMessage.fragment = __ProductSupportingMessageFragment;
// src/components/product-headline/use-product-headline.tsx
import { useMemo } from "react";
var useProductHeadline = function(productHeadline, placeholderData, mockData) {
    return useMemo(function() {
        if (!productHeadline && !mockData) {
            return placeholderData;
        }
        return productHeadline !== null && productHeadline !== void 0 ? productHeadline : mockData;
    }, [
        productHeadline,
        placeholderData,
        mockData
    ]);
};
// src/components/product-headline/product-headline.tsx
var __Query = gql4(_templateObject3(), ProductSupportingMessage.fragment);
var ProductHeadline = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, batchKey = param.batchKey, placeholderData = param.placeholderData, _param_inlineRating = param.inlineRating, inlineRating = _param_inlineRating === void 0 ? false : _param_inlineRating;
    var _mockData_product, _mockData_product1;
    var mockData = useMockData();
    var context = useBexApi().context;
    var DEFAULT_BATCH_KEY = "default-product-details-experience-batch-key";
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        context: {
            useApq: true,
            batchKey: batchKey !== null && batchKey !== void 0 ? batchKey : DEFAULT_BATCH_KEY
        },
        variables: variables,
        ssr: !skipSsr,
        skip: mockData === null || mockData === void 0 ? void 0 : (_mockData_product = mockData.product) === null || _mockData_product === void 0 ? void 0 : _mockData_product.headline
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    var syncedProductHeadline = useProductHeadline(data === null || data === void 0 ? void 0 : data.productHeadline, placeholderData, mockData === null || mockData === void 0 ? void 0 : (_mockData_product1 = mockData.product) === null || _mockData_product1 === void 0 ? void 0 : _mockData_product1.headline);
    if (loading && !(syncedProductHeadline === null || syncedProductHeadline === void 0 ? void 0 : syncedProductHeadline.primary)) {
        return /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement(EGDSSpacing, {
            margin: {
                blockend: "two"
            }
        }, /* @__PURE__ */ React14.createElement(EGDSLineSkeleton, {
            animation: true,
            type: "primary"
        })), /* @__PURE__ */ React14.createElement(EGDSLineSkeleton, {
            animation: true,
            type: "secondary"
        }));
    }
    if (error || !(syncedProductHeadline === null || syncedProductHeadline === void 0 ? void 0 : syncedProductHeadline.primary)) {
        return null;
    }
    var primary = syncedProductHeadline.primary, secondary = syncedProductHeadline.secondary, rating = syncedProductHeadline.rating, supportingMessages = syncedProductHeadline.supportingMessages, featuredMessages = syncedProductHeadline.featuredMessages;
    var _rating_accessibility;
    var ratingInline = (rating === null || rating === void 0 ? void 0 : rating.icon.id) && inlineRating ? /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement(EGDSSpacing, {
        padding: {
            inlinestart: "two"
        }
    }, /* @__PURE__ */ React14.createElement("span", null)), /* @__PURE__ */ React14.createElement(EGDSRating, {
        icon: rating.icon.id === "star" ? "star" : "alternate",
        rating: "".concat(rating.rating),
        a11yText: (_rating_accessibility = rating.accessibility) !== null && _rating_accessibility !== void 0 ? _rating_accessibility : void 0
    })) : null;
    var _rating_accessibility1;
    return /* @__PURE__ */ React14.createElement(EGDSSpacing, {
        padding: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React14.createElement("div", null, /* @__PURE__ */ React14.createElement(EGDSSpacing, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React14.createElement(EGDSLayoutFlex, {
        space: "two",
        className: "uitk-type-300",
        alignItems: "center"
    }, featuredMessages.length > 0 && /* @__PURE__ */ React14.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React14.createElement("div", null, featuredMessages.map(function(message, index) {
        return /* @__PURE__ */ React14.createElement(React14.Fragment, null, index !== 0 && /* @__PURE__ */ React14.createElement(EGDSSpacing, {
            margin: {
                inline: "half"
            }
        }, /* @__PURE__ */ React14.createElement(EGDSText2, {
            inline: true
        }, "\xB7")), /* @__PURE__ */ React14.createElement(ProductSupportingMessage, {
            data: message,
            key: "featured-message-".concat(message.__typename, "-").concat(index),
            inline: true
        }));
    }))))), /* @__PURE__ */ React14.createElement(Viewport, null, /* @__PURE__ */ React14.createElement(ViewSmall, null, /* @__PURE__ */ React14.createElement(EGDSHeading, {
        tag: "h1",
        size: 4,
        "aria-hidden": "true"
    }, primary, ratingInline)), /* @__PURE__ */ React14.createElement(ViewLarge, null, /* @__PURE__ */ React14.createElement(EGDSHeading, {
        tag: "h1",
        size: 3,
        "aria-hidden": "true"
    }, primary, ratingInline))), primary && /* @__PURE__ */ React14.createElement("meta", {
        itemProp: "name",
        content: primary
    }), secondary && /* @__PURE__ */ React14.createElement(EGDSSubheading, {
        tag: "h2"
    }, secondary), (rating === null || rating === void 0 ? void 0 : rating.icon.id) && !inlineRating && /* @__PURE__ */ React14.createElement(EGDSSpacing, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React14.createElement(EGDSRating, {
        icon: rating.icon.id === "star" ? "star" : "alternate",
        rating: "".concat(rating.rating),
        a11yText: (_rating_accessibility1 = rating.accessibility) !== null && _rating_accessibility1 !== void 0 ? _rating_accessibility1 : void 0
    })), supportingMessages === null || supportingMessages === void 0 ? void 0 : supportingMessages.map(function(message, index) {
        var spacingProps = {};
        switch(message.__typename){
            case "EGDSPlainText":
                spacingProps = {
                    padding: {
                        blockstart: index !== 0 ? "two" : "unset"
                    },
                    margin: {
                        inlinestart: inlineRating ? "half" : "unset"
                    }
                };
                break;
            case "EGDSStandardBadge":
                spacingProps = {
                    padding: {
                        blockstart: "three",
                        blockend: "one"
                    }
                };
                break;
            case "EGDSInlineLink":
                spacingProps = {
                    margin: {
                        blockstart: "one"
                    }
                };
                break;
            default:
                break;
        }
        return /* @__PURE__ */ React14.createElement(EGDSSpacing, _object_spread({
            key: "message-".concat(message.__typename, "-").concat(index)
        }, spacingProps), /* @__PURE__ */ React14.createElement("div", null, /* @__PURE__ */ React14.createElement(ProductSupportingMessage, {
            data: message
        })));
    })));
};
ProductHeadline.displayName = "sharedui-ProductHeadline";
// src/__generated__/types.ts
var IdentifierType = /* @__PURE__ */ function(IdentifierType2) {
    IdentifierType2["ACTIVITY_ID"] = "ACTIVITY_ID";
    IdentifierType2["CART_ID"] = "CART_ID";
    IdentifierType2["CHECKOUT_SESSION_ID"] = "CHECKOUT_SESSION_ID";
    IdentifierType2["ENTITY_ID"] = "ENTITY_ID";
    IdentifierType2["LEGACY_ORDER_ID"] = "LEGACY_ORDER_ID";
    IdentifierType2["OFFER_ID"] = "OFFER_ID";
    IdentifierType2["ORDER_ID"] = "ORDER_ID";
    IdentifierType2["PROPERTY_ID"] = "PROPERTY_ID";
    IdentifierType2["SAILING_TOKEN"] = "SAILING_TOKEN";
    return IdentifierType2;
}(IdentifierType || {});
export { IdentifierType, ProductHeadline }; /*! Bundled license information:

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** *)
*/ 
//# sourceMappingURL=index.js.map